import { createDamState } from "../types/dam-state/dam-state.functions";
import { DamActions, DamActionType } from "./dam.actions";
import { DamState } from "../types/dam-state/dam-state.interface";

export function damReducer(state = createDamState(), action: DamActionType): DamState {
  switch (action.type) {
    case DamActions.Init:
      return {
        ...state,
        isLoading: true,
      };
    case DamActions.FetchSignatureSuccess:
      return {
        ...state,
        isLoading: false,
        signature: action.payload.signature,
        signatureFetchedAt: action.payload.date,
      };
    default:
      return state;
  }
}
